import { createFileRoute } from '@tanstack/react-router';

import { ActivityFeedPage } from '@/features/activity';

export const Route = createFileRoute('/_authenticated/_withWorkspace/activity')({
  component: ActivityFeedPage,
});
